import React, { Component } from 'react'
import Form from 'react-bootstrap/Form'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import ReactMarkdown from 'react-markdown'

import './DescriptionEditor.css'


class AuthEditor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      error: null,
    }
  }

  descriptionChange(ev) {
    if (!this.props.onChange) {
      return
    }
    this.props.onChange(ev.target.value)
  }

  render() {
    return <div className='DescriptionEditor'>
      {this.props.readonly ? this.props.description : <Tabs>
        <Tab eventKey="markdown" title="テキスト">
          <div className='MarkdownEditor'>
            <Form.Control
              data-test-task-description
              as='textarea'
              name='text'
              rows='3'
              disabled={this.props.disabled}
              defaultValue={this.props.description}
              placeholder='ここに英文の簡単な説明を入力してください。(任意)'
              onChange={e => this.descriptionChange(e)} />
          </div>
          <div className='MarkdownNotice'>
            * <a
                href='https://www.markdown.jp/syntax/'
                target='_blank'
                rel='noopener noreferrer'
              >Markdown記法</a>を使用できます。
          </div>
        </Tab>
        <Tab eventKey="preview" title="プレビュー">
          {!this.props.description || this.props.description.length === 0 ?
          <div className='NoMarkdownContent'>説明が入力されていません</div> :
          <div className='MarkdownPreview'>
            <ReactMarkdown>
              {this.props.description}
            </ReactMarkdown>
          </div>}
        </Tab>
      </Tabs>}
    </div>
  }
}

export default AuthEditor;
